// extracted by mini-css-extract-plugin
module.exports = {"goldButton":"Style_goldButton__1bEHr","fLogo":"Style_fLogo__2RD5F"};